import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Menu, X, Play } from 'lucide-react';
import { ImageSlider } from './components/ImageSlider';
function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [isTeamExpanded, setIsTeamExpanded] = useState(false);
  const [isEventImagesExpanded, setIsEventImagesExpanded] = useState(false);
  const eventImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k443DHwXjcGVMkoyTVB7hE/ams-screening1.jpg',
    alt: 'Speaker at Amsterdam screening event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hQ9K3AK4SchrNqj4VUJX67/ams-screening2.jpg',
    alt: 'Panel discussion at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mk12QnRVRev2b91HasdoT3/ams-screening6.jpg',
    alt: 'Attendees in conversation at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jHyugobVEDFAvxHNtzQbuq/ams-screening7.jpg',
    alt: 'Panel discussion with female speaker at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e34uFhXF9zvbi39bpDpswG/ams-screening8.jpg',
    alt: 'Moderator introducing speakers at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sp2GD1Y7NRmrPRNFN23LjE/ams-screening4.jpg',
    alt: 'Producers in conversation at Amsterdam screening event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5FdNn1yQminT3cNfV3MjEf/ams-screening5.jpg',
    alt: 'Attendees in discussion at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6J5NThdpuPd1FKAR2uMM17/ams-screening3.jpg',
    alt: 'Panel discussion with speakers at Amsterdam screening'
  }];
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const sections = ['hero', 'about', 'trailer', 'watch', 'in-the-media', 'team', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <Router data-id="element-0" data-mp="3qdag2h72xzuh">
      <div className="relative w-full min-h-screen bg-black font-sans" data-id="element-1" data-mp="3lkhe212zx5m3">
        <div className="mx-auto max-w-[1920px] relative" data-id="element-2" data-mp="3lj6bg4lae3wk">
          <section id="hero" className="relative w-full overflow-hidden" style={{
          aspectRatio: '1920/1080'
        }} data-id="element-3" data-mp="2xu3ja2t10snt">
            <div className="absolute inset-0 flex justify-end" data-id="element-4" data-mp="18d9c849dngr4">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/32d35855-03bc-42fa-88d9-49f33f2322a4/EEM-hero-desktop-1920.jpg" alt="Everything Else Matters Documentary" className="h-full w-full object-cover object-center sm:object-right" data-id="element-5" data-mp="18byae9zhsj2n" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/30 z-20" data-id="element-6" data-mp="1r5ak1w44qhco" />
            <div className="absolute inset-0 flex flex-col justify-center px-4 sm:px-8 text-white text-left z-30 pt-12 sm:pt-0" data-id="element-7" data-mp="1w211onvl1l07">
              <div className="max-w-full" data-id="element-8" data-mp="1i5nh35vr53hi">
                <h1 className="font-['Bebas_Neue'] text-4xl xs:text-3xl sm:text-5xl md:text-8xl lg:text-9xl font-normal tracking-wide mb-2 xs:mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-white to-blue-400 leading-[0.9]" data-id="element-9" data-mp="1m4eihp7937af">
                  EVERYTHING
                  <br data-id="element-10" data-mp="qwvos6dw892o" />
                  ELSE
                  <br data-id="element-11" data-mp="qxx9z3omiby4" />
                  MATTERS
                </h1>
                <p className="font-sans text-sm xs:text-base sm:text-xl md:text-2xl mb-2 xs:mb-4 font-light tracking-wide text-purple-500" data-id="element-12" data-mp="m5xa1b8jzj1j">
                  Deconstructing Psychedelic Experience
                </p>
                <p className="font-sans text-xs xs:text-sm sm:text-lg md:text-xl font-light tracking-widest text-purple-500 mb-4 xs:mb-8" data-id="element-13" data-mp="c9am2dkxkbva">
                  A Film by Antoine Bellanger
                </p>
                <div className="flex flex-col items-start mt-1 xs:mt-2" data-id="element-14" data-mp="14y85wl4sigq5">
                  <a href="#trailer" className="inline-flex items-center px-4 xs:px-5 py-2 xs:py-2.5 bg-purple-500/20 hover:bg-purple-500/30 border border-purple-500/50 rounded-lg text-white transition-all duration-300 hover:scale-105 backdrop-blur-sm group text-xs xs:text-sm sm:text-base" onClick={e => {
                  e.preventDefault();
                  document.getElementById('trailer')?.scrollIntoView({
                    behavior: 'smooth'
                  });
                  setTimeout(() => {
                    const iframe = document.querySelector('#trailer iframe');
                    if (iframe) {
                      const src = iframe.getAttribute('src');
                      if (src) {
                        iframe.setAttribute('src', `${src}?autoplay=1`);
                      }
                    }
                  }, 1000);
                }} data-id="element-15" data-mp="zxals307zcm0">
                    <Play className="w-3 h-3 xs:w-4 xs:h-4 mr-1 xs:mr-2 group-hover:scale-110 transition-transform" data-id="element-16" data-mp="2nwnubbuizbs9" />
                    Watch the Trailer
                  </a>
                </div>
              </div>
            </div>
          </section>
          <nav className="md:fixed relative left-0 right-0 z-50 font-display md:top-0" data-id="element-17" data-mp="ygoi1lvm168e">
            <div className="max-w-[1920px] mx-auto" data-id="element-18" data-mp="yihpv4hylwhz">
              <div className="backdrop-blur-lg bg-black/80 border-b border-purple-500/20" data-id="element-19" data-mp="21slv64wn1cwn">
                <div className="max-w-7xl mx-auto px-6" data-id="element-20" data-mp="1wtiyb7qtaczr">
                  <div className="flex justify-between items-center h-20" data-id="element-21" data-mp="2as8v0m9pyanl">
                    <div className="text-xl font-bold" data-id="element-22" data-mp="2atjzkoaznmfr">
                      <a href="#hero" className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400 hover:scale-105 transition-transform" data-id="element-23" data-mp="25sw7dzb0wzjy">
                        EEM
                      </a>
                    </div>
                    <div className="hidden md:flex space-x-12" data-id="element-24" data-mp="2thozfkoiyn9a">
                      {['About', 'Trailer', 'Watch', 'In the Media', 'Team', 'Contact'].map(item => {
                      const sectionId = item.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-');
                      return <a key={item} href={`#${sectionId}`} className={`text-lg tracking-wide transition-all duration-300 ${activeSection === sectionId ? 'text-purple-400 scale-105' : 'text-white/90 hover:text-purple-300'}`} data-id="element-25" data-mp="385gw2c6ozz41">
                            {item}
                          </a>;
                    })}
                    </div>
                    <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-26" data-mp="2pcuurcd0ngc2">
                      {isMobileMenuOpen ? <X size={24} data-id="element-27" data-mp="2ggn6voybbbib" /> : <Menu size={24} data-id="element-28" data-mp="2kfuvbkao9btx" />}
                    </button>
                  </div>
                </div>
              </div>
              {isMobileMenuOpen && <div className="md:hidden py-6 backdrop-blur-lg bg-black/80 border-b border-purple-500/20" data-id="element-29" data-mp="30tawdw5r9i31">
                  <div className="flex flex-col space-y-6 px-6" data-id="element-30" data-mp="2vug3g1e2qd57">
                    {['About', 'Trailer', 'Watch', 'In the Media', 'Team', 'Contact'].map(item => {
                  const sectionId = item.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-');
                  return <a key={item} href={`#${sectionId}`} className={`text-lg tracking-wide transition-all duration-300 ${activeSection === sectionId ? 'text-purple-400' : 'text-white/90 hover:text-purple-300'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-31" data-mp="238540u27ei9z">
                          {item}
                        </a>;
                })}
                  </div>
                </div>}
            </div>
          </nav>
          <section id="about" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden pt-20" data-id="element-32" data-mp="nonrc9xkviyy">
            <div className="absolute inset-0" data-id="element-33" data-mp="3m84a9ft8twfz">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/d6901fa4-135d-4cb8-89a1-c38f77490516/EEM-2nd-screen-1920.jpg" alt="Second screen background" className="w-full h-full object-cover" data-id="element-34" data-mp="3r4uso9sit44k" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-35" data-mp="33g3926szxu3e" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-36" data-mp="38duzewdzt85h">
              <div className="max-w-3xl" data-id="element-37" data-mp="2f7n4bseaibjy">
                <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-300 to-purple-400" data-id="element-38" data-mp="2f6vhp72o7o5t">
                  About the Film
                </h2>
                <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-39" data-mp="2p387vuz0bjvt">
                  <div className="space-y-6" data-id="element-40" data-mp="2u3vzahr5e2qk">
                    <div className="mb-8" data-id="element-41" data-mp="1wgvuyquayl5k">
                      <p className="font-display text-3xl text-purple-300 mb-2" data-id="element-42" data-mp="1whyoz7mx93pp">
                        Everything Else Matters: Deconstructing Psychedelic
                        Experience
                      </p>
                      <p className="text-lg text-purple-200" data-id="element-43" data-mp="26dig7gqjje84">
                        Feature Documentary Film, 61 minutes
                      </p>
                    </div>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-44" data-mp="1dpctiofxff5n">
                      <i data-id="element-45" data-mp="1iopj3gy6n0bx">Everything Else Matters</i> is a non-profit documentary
                      project created to deepen public understanding of
                      psychedelic experiences.
                    </p>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-46" data-mp="3rz8cenrur790">
                      Produced in collaboration with the OPEN Foundation and the
                      Improbability Foundation, the film brings together leading
                      researchers, clinicians, and practitioners to examine the
                      science of set, setting, and the inner mechanisms of these
                      journeys. Our mission is to make complex knowledge
                      accessible, promote safer and more beneficial practices,
                      and support an informed, responsible conversation about
                      the therapeutic potential of psychedelics.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="trailer" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-47" data-mp="2pblmrltdf8e9">
            <div className="absolute inset-0" data-id="element-48" data-mp="2kmsy0ao59o5g">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/c4c40fec-51a6-4fcc-a14a-71e4e382ded4/EEM-4th-screen-1920.jpg" alt="Third screen background" className="w-full h-full object-cover" data-id="element-49" data-mp="2kkg6p6why1fq" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-50" data-mp="2yepmm4qltfx3" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-51" data-mp="33evaraxo0kaf">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-52" data-mp="2pjje2xzy8jqv">
                Trailer
              </h2>
              <div className="aspect-video w-full max-w-4xl mx-auto rounded-lg overflow-hidden shadow-2xl" data-id="element-53" data-mp="3hap6es9fhd5l">
                <iframe src="https://player.vimeo.com/video/1066137162" width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-54" data-mp="3m5cxmyvtglnv"></iframe>
              </div>
            </div>
          </section>
          <section id="watch" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-55" data-mp="rpp23f41vwdw">
            <div className="absolute inset-0" data-id="element-56" data-mp="ms5eholgq79a">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/73495e13-8051-4657-b489-8adaee858f21/EEM-5th-screen-1920.jpg" alt="Watch section background" className="w-full h-full object-cover" data-id="element-57" data-mp="11nlcu5t2spbh" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-58" data-mp="283x921cc7x4f" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-59" data-mp="hnldgxexni65">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-60" data-mp="mlmwjicczhhm">
                Watch
              </h2>
              <div className="backdrop-blur-sm bg-black/20 p-8 rounded-lg max-w-3xl" data-id="element-61" data-mp="vmcogayi0nq2">
                <div className="space-y-8" data-id="element-62" data-mp="10lp68haij4ls">
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-63" data-mp="10kw9m959pvhd">
                    <p className="text-xl md:text-2xl mb-2" data-id="element-64" data-mp="15k8u4n8o2qgs">
                      <a href="https://www.gaia.com/video/everything-else-matters" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors flex items-center" data-id="element-65" data-mp="15inzkxmcr7ix">
                        Gaia - Global
                        <span className="ml-2 text-green-400 text-sm bg-green-400/10 px-2 py-0.5 rounded" data-id="element-66" data-mp="1oc1pupf4eps7">
                          Available Now
                        </span>
                      </a>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-67" data-mp="1ti6v35uhdscq">
                      Stream worldwide on the Gaia platform
                    </p>
                  </div>
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-68" data-mp="1kgqufptgx4lp">
                    <p className="text-xl md:text-2xl mb-2" data-id="element-69" data-mp="2h67wzvx5maj6">
                      <a href="https://amazon.com/Everything-Else-Matters-Antoine-Bellanger/dp/B0FC6BXR94" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors flex items-center" data-id="element-70" data-mp="2h7sp7evzxhdv">
                        Amazon Prime Video - US/UK
                        <span className="ml-2 text-green-400 text-sm bg-green-400/10 px-2 py-0.5 rounded" data-id="element-71" data-mp="2zy0rjurvg3t0">
                          Available Now
                        </span>
                      </a>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-72" data-mp="y7jqmywfvjz0">
                      Stream in the United States and United Kingdom
                    </p>
                  </div>
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-73" data-mp="jg9q90r378uj">
                    <p className="text-xl md:text-2xl mb-2" data-id="element-74" data-mp="ofmareuhk3ty">
                      <a href="https://www.youtube.com/watch?v=sT-3qMu3IX0" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors flex items-center" data-id="element-75" data-mp="ah67xyzquxh3">
                        Best Documentary - Worldwide
                        <span className="ml-2 text-green-400 text-sm bg-green-400/10 px-2 py-0.5 rounded" data-id="element-76" data-mp="1uxiy0q0uscg0">
                          Available Now
                        </span>
                      </a>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-77" data-mp="3kdmurwpzdys0">
                      Watch from anywhere
                    </p>
                  </div>
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-78" data-mp="3fd8q8onl96yq">
                    <p className="text-xl md:text-2xl mb-2" data-id="element-79" data-mp="3u4zneqjlssz3">
                      <a href="https://www.youtube.com/watch?v=T0Q4tUfFnp0" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors flex items-center" data-id="element-80" data-mp="3pczkcp88ljya">
                        wocomoDOCS - Worldwide
                        <span className="ml-2 text-green-400 text-sm bg-green-400/10 px-2 py-0.5 rounded" data-id="element-81" data-mp="gvbrhkgp9oor">
                          Available Now
                        </span>
                      </a>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-82" data-mp="2dqhmy6r2c2y4">
                      Watch from anywhere
                    </p>
                  </div>
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-83" data-mp="1rwipkdiyop83">
                    <p className="text-xl md:text-2xl mb-2 text-purple-300 flex items-center" data-id="element-84" data-mp="1wutzspd651qu">
                      Spirit SVOD Platform - Netherlands/Belgium
                      <span className="ml-2 text-amber-400 text-sm bg-amber-400/10 px-2 py-0.5 rounded" data-id="element-85" data-mp="26lowyorydlr2">
                        Coming Soon
                      </span>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-86" data-mp="190aprp8px6k6">
                      Available soon for streaming in the Netherlands and
                      Belgium
                    </p>
                  </div>
                  <div className="pb-2" data-id="element-87" data-mp="1nv75eniuww7a">
                    <p className="text-xl md:text-2xl mb-2 text-purple-300 flex items-center" data-id="element-88" data-mp="1nvytzee1dto2">
                      HOT VOD Platform - Israel
                      <span className="ml-2 text-amber-400 text-sm bg-amber-400/10 px-2 py-0.5 rounded" data-id="element-89" data-mp="2udlvje6e6ha8">
                        Coming Soon
                      </span>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-90" data-mp="notpulziud4v">
                      Available soon for streaming in Israel
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="in-the-media" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-91" data-mp="8yw6qkgg8dmj">
            <div className="absolute inset-0" data-id="element-92" data-mp="3w2tzbkfbv2de">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1qnMecJidvSNgS7q5DLspH/EEM-3rd-screen-1920.jpg" alt="Media section background" className="w-full h-full object-cover" data-id="element-93" data-mp="3w20zz4ip7f5a" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-94" data-mp="1pccpigxgxiwt" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-95" data-mp="1kd01vtyrw7t6">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400" data-id="element-96" data-mp="2c72s4s45i55t">
                In the Media
              </h2>
              <div className="flex flex-col lg:flex-row gap-12" data-id="element-97" data-mp="22h12vx02agpb">
                <div className="lg:w-1/2" data-id="element-98" data-mp="22fgbgg91ndvo">
                  <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-99" data-mp="1xj7xh66l1qq3">
                    <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-100" data-mp="1tgl4v32381ru">
                      Events
                    </h3>
                    <div className="space-y-6" data-id="element-101" data-mp="1og6sx9xd87oj">
                      <div className="border-l-2 border-purple-400 pl-6 mb-6" data-id="element-102" data-mp="1jif26j8girlx">
                        <p className="text-white/90 text-lg mb-2" data-id="element-103" data-mp="1jki15srl7v2s">
                          <span className="text-purple-200 font-medium" data-id="element-104" data-mp="1el546f7057mh">
                            11 June 2025
                          </span>{' '}
                          - Amsterdam screening at LAB111
                        </p>
                        <p className="text-white/90 mb-4" data-id="element-105" data-mp="38vs6w9khehnk">
                          Introduction by Joost Breeksema and Dmitry Repin.
                          Everything Else Matters documentary screening followed
                          by a panel discussion on the state of psychedelic
                          therapy.
                        </p>
                        <ImageSlider images={eventImages} data-id="element-106" data-mp="3v4pbqnehmksf" />
                      </div>
                    </div>
                  </div>
                  <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg mt-12" data-id="element-107" data-mp="2yi45k1703vha">
                    <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-108" data-mp="32hmnqp7ftsgf">
                      Music & Video
                    </h3>
                    <div className="space-y-6" data-id="element-109" data-mp="3cfsrlcct18nx">
                      <div className="border-l-2 border-purple-400 pl-6 mb-6" data-id="element-110" data-mp="3cdfz459f7fwm">
                        <p className="text-white/90 text-lg mb-4" data-id="element-111" data-mp="mpp2rbqxw2uk">
                          "Run Little Baby" song by{' '}
                          <a href="https://www.youtube.com/@sfor7music" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-112" data-mp="rredsre5wgin">
                            S for 7
                          </a>
                        </p>
                        <div className="aspect-video w-full rounded-lg overflow-hidden shadow-lg mb-4" data-id="element-113" data-mp="3fg2dtzosee3j">
                          <iframe src="https://www.youtube.com/embed/F1mhC-GiL4s" width="100%" height="100%" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-114" data-mp="3ah7vszyn8tkh"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:w-1/2" data-id="element-115" data-mp="1bzfisdkzx02k">
                  <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-116" data-mp="1c0gwkptec0nz">
                    <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-117" data-mp="xbkst4ydh9t6">
                      Reviews
                    </h3>
                    <div className="space-y-6" data-id="element-118" data-mp="1pyxc9698l1i9">
                      <blockquote className="border-l-2 border-purple-400 pl-6" data-id="element-119" data-mp="1q08ev2qy437s">
                        <p className="text-white/90 text-lg italic mb-6" data-id="element-120" data-mp="1uy9vzi4t9sgm">
                          "Everything Else Matters gives a rich picture of the
                          state of the art of current research in psychedelics.
                          The latest scientific insights and age-old ceremonial
                          wisdom are brought together and aligned with
                          experiential accounts and rich visualizations. The
                          film gives profound insight into the potential
                          benefits and possible dangers of psychedelics, all
                          depending on set, setting and dosage."
                        </p>
                        <footer className="text-purple-200" data-id="element-121" data-mp="g31y9nq5m8vu">
                          <p className="font-medium" data-id="element-122" data-mp="b2xhrxp8xe5m">Patricia Pisters</p>
                          <p className="text-sm text-purple-200/80" data-id="element-123" data-mp="b0ufae6wpsk0">
                            Professor of Film Studies, University of Amsterdam
                          </p>
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="team" className={`min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden transition-all duration-500 ${isTeamExpanded ? 'h-auto' : 'h-screen'}`} data-id="element-124" data-mp="upv6k919aeej">
            <div className="absolute inset-0" data-id="element-125" data-mp="3fj8bfb8744h7">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/ffc0661c-0f7e-4689-888d-30d00dbed792/EEM-7th-screen-1920.jpg" alt="Team section background" className="w-full h-full object-cover" data-id="element-126" data-mp="1uzw5wi08i5ih" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-127" data-mp="28r19twamxjym" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-128" data-mp="2dot06lvmsy0p">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400" data-id="element-129" data-mp="2inw7kcz33gbu">
                Team
              </h2>
              <div className={`relative ${!isTeamExpanded && 'max-h-[60vh] overflow-hidden'}`} data-id="element-130" data-mp="2rpvlgwesy4ak">
                <div className="flex flex-col lg:flex-row gap-12" data-id="element-131" data-mp="sdjec58lveud">
                  <div className="lg:w-1/2" data-id="element-132" data-mp="xat3djs31oho">
                    <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-133" data-mp="xbky6sduvi6w">
                      <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-134" data-mp="20n1lxsqjvg9a">
                        Crew
                      </h3>
                      <div className="space-y-4" data-id="element-135" data-mp="29mwzu5bhppd0">
                        {[{
                        position: 'Director',
                        name: 'Antoine Bellanger'
                      }, {
                        position: 'Producers',
                        name: 'Dmitry Repin, Joost Breeksema, Mack Kennedy'
                      }, {
                        position: 'Camera',
                        name: 'Martina Trepczyk (Girona, Amsterdam, Leiden, Vienna), Charles Antoine Bellanger, Istvàn Gábor Takács (Haarlem)'
                      }, {
                        position: 'Editor',
                        name: 'Antoine Bellanger'
                      }, {
                        position: 'Score',
                        name: 'Hariton'
                      }, {
                        position: 'Sound/Assistant Camera',
                        name: 'Rian Davidson (Girona, Amsterdam, Leiden)'
                      }, {
                        position: 'Associate Producer/International Sales',
                        name: 'Olga Tchekhoff'
                      }, {
                        position: 'Assistant Editor',
                        name: 'Lola Norymberg'
                      }, {
                        position: 'Voice Artists',
                        name: 'Scarlett Butler, Charles Gibbons, Nguyen Harrington, Eleanor Melinn, Paul Woodson, Michael Workman, Petar Zakavica'
                      }, {
                        position: 'Sound Mixer',
                        name: 'Petros Drossos'
                      }, {
                        position: 'Color Correction',
                        name: 'Florian Jarry'
                      }, {
                        position: 'Shooting Locations',
                        name: 'Spain, Austria, The Netherlands'
                      }].map((item, index) => <div key={index} className="border-b border-white/10 pb-4" data-id="element-136" data-mp="2bye5rwu6s72a" data-mpi={index}>
                            <div className="font-medium text-purple-200" data-id="element-137" data-mp="223m52k5b543a">
                              {item.position}
                            </div>
                            <div className="text-white/90" data-id="element-138" data-mp="1t1v2ho62dddn">{item.name}</div>
                          </div>)}
                      </div>
                    </div>
                  </div>
                  <div className="lg:w-1/2" data-id="element-139" data-mp="ckw49nshzkdt">
                    <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-140" data-mp="cjky5hbky0jj">
                      <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-141" data-mp="hlk2atf591hj">
                        Interviewees
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-142" data-mp="3l0zbxtjm1925">
                        {['Adnan', 'Alejandro Carbó', 'Alexander Ehrmann', 'Andrew McLeod', 'Ben Sheinwald', 'Chloé Pronovost-Morgan', 'Christopher Timmermann', 'Daan Keiman', 'David Dupuis', 'Grace Blest Hopley', 'Gül Dölen', 'Ivan Jagdish', 'Joost Breeksema', 'Nicholas Canby', 'Nicholas Langlitz', 'Karin Silenzi di Stagni', 'Leor Roseman', 'Indri Tulusan', 'Tamara Slock', 'Tijmen Bostoen', 'Wim van den Brink'].map((name, index) => <div key={index} className="border-b border-white/10 pb-2 text-white/90" data-id="element-143" data-mp="22zvwk0tnr3ly" data-mpi={index}>
                            {name}
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                {!isTeamExpanded && <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/20 to-transparent" data-id="element-144" data-mp="1k94qb84yvtbs" />}
              </div>
              <div className="relative z-20 w-full bg-black/20 backdrop-blur-sm py-8" data-id="element-145" data-mp="10nutpfqrfcl6">
                <div className="max-w-7xl mx-auto px-8" data-id="element-146" data-mp="vq2q3ogr6215">
                  <button onClick={() => setIsTeamExpanded(!isTeamExpanded)} className="mx-auto block text-purple-400 hover:text-purple-300 transition-colors" data-id="element-147" data-mp="19osmt2zntzoz">
                    {isTeamExpanded ? 'Show Less' : 'Show More'}
                  </button>
                </div>
              </div>
            </div>
          </section>
          <section id="contact" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-148" data-mp="1tca2vln7n0ol">
            <div className="absolute inset-0" data-id="element-149" data-mp="1odyuzggh7090">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/57e9d2ef-278e-49ae-8999-b4cd111ef88c/EEM-6th-screen-1920.jpg" alt="Contact section background" className="w-full h-full object-cover" data-id="element-150" data-mp="22cf0x56ikmq3" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-151" data-mp="zzaea5jlynjc" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-152" data-mp="1402q96jv76jb">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400" data-id="element-153" data-mp="18sdrccqccydg">
                Contact
              </h2>
              <div className="backdrop-blur-sm bg-black/20 p-8 rounded-lg max-w-2xl" data-id="element-154" data-mp="1ipid4bg9yrtq">
                <div className="space-y-8" data-id="element-155" data-mp="1npe7rk3316wm">
                  <div className="border-l-4 border-purple-400/50 pl-6 py-2" data-id="element-156" data-mp="1nqfs6f5zn5r0">
                    <h3 className="text-xl font-display font-bold mb-2 text-purple-300" data-id="element-157" data-mp="1rqzpbiqka9d5">
                      Distribution
                    </h3>
                    <p className="text-white/90" data-id="element-158" data-mp="3pikglgoa3kwz">
                      Please contact Jambica DOCS:{' '}
                      <a href="mailto:juan@jambikadocs.com" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-159" data-mp="3tjwahye6qsaz">
                        juan@jambikadocs.com
                      </a>
                    </p>
                  </div>
                  <div className="border-l-4 border-purple-400/50 pl-6 py-2" data-id="element-160" data-mp="387fbuk52ma7e">
                    <h3 className="text-xl font-display font-bold mb-2 text-purple-300" data-id="element-161" data-mp="385cbp7a7f0oy">
                      Events, Screenings, & Partnerships
                    </h3>
                    <p className="text-white/90" data-id="element-162" data-mp="3tgt4ztgotzd">
                      Please contact the producers at:{' '}
                      <a href="mailto:EEMdocumentary@gmail.com" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-163" data-mp="3vuwy605kgg2z">
                        EEMdocumentary@gmail.com
                      </a>
                    </p>
                  </div>
                  <div className="border-l-4 border-purple-400/50 pl-6 py-2" data-id="element-164" data-mp="79s63wiywail">
                    <h3 className="text-xl font-display font-bold mb-2 text-purple-300" data-id="element-165" data-mp="77p5yjo3p105">
                      Social Media
                    </h3>
                    <div className="space-y-3" data-id="element-166" data-mp="3ufapqc4yc02k">
                      <p className="text-white/90" data-id="element-167" data-mp="3uces6ox0nden">
                        <span className="text-white/70" data-id="element-168" data-mp="29xajfo8ywr7">X: </span>
                        <a href="https://x.com/eem_documentary" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-169" data-mp="q09rth5du5ug">
                          @EEM_documentary
                        </a>
                      </p>
                      <p className="text-white/90" data-id="element-170" data-mp="31pu0togjj1b3">
                        <span className="text-white/70" data-id="element-171" data-mp="31o953vihpcbn">Instagram: </span>
                        <a href="https://instagram.com/eem_documentary/" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-172" data-mp="36p6vgvdnlco8">
                          @EEM_documentary
                        </a>
                      </p>
                      <p className="text-white/90" data-id="element-173" data-mp="33812842rh6qs">
                        <span className="text-white/70" data-id="element-174" data-mp="2fhet09h0tgf7">YouTube: </span>
                        <a href="https://youtube.com/@EverythingElseMatters" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-175" data-mp="2fholq4tga1ol">
                          @EverythingElseMatters
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Router>;
}
export default App;